export const getImageUrl = (url) => {
  if (!url) return '';
  // Cloudinary URLs are already absolute
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  // Local URLs need the backend prefix
  return url.startsWith('/') ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url;
};
